import { useCustom } from "@refinedev/core";
import { useSearchParams } from "react-router";
import { ClaraAuthPage } from "../components/ClaraAuthPage";
import { Spin } from "antd";
import type { SubmitLinkRecoveryTokenMutation } from "../../../graphql/gmbh/schema/gmbh-types";
import { SubmitLinkRecoveryTokenDocument } from "../../../graphql/gmbh/schema/gmbh-types";
import { print } from "graphql";

const UpdatePasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const flowId = searchParams.get("flow");
  const token = searchParams.get("token");

  const { data, isLoading, isError } = useCustom<SubmitLinkRecoveryTokenMutation>({
    method: "post",
    url: "",
    meta: {
      operation: print(SubmitLinkRecoveryTokenDocument),
      variables: {
        input: {
          flowID: flowId,
          token: token,
          nativeApp: false,
        },
      },
    },
    queryOptions: {
      enabled: !!flowId && !!token,
    },
  });

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isError) {
    return <div>Error occurred while validating your token. Please try again.</div>;
  }

  if (!data?.data?.submitLinkRecoveryToken) {
    return <div>Invalid or expired token. Please request a new password reset link.</div>;
  }

  return <ClaraAuthPage type="updatePassword" />;
};

export default UpdatePasswordPage;
